import { useEffect, useState } from 'react'

import Api from 'services/api'

import { EquipmentImage } from 'types/EquipmentImage'

const useEquipmentImage = (modelNumber: string, refresh?: number) => {
  const [equipmentImage, setEquipmentImage] = useState<EquipmentImage | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    Api.SystemComponents.getEquipmentImage(modelNumber, false)
      .then((res) => {
        setEquipmentImage(res)
        setIsLoaded(true)
      })
      .catch(() => {
        setEquipmentImage(null)
        setIsLoaded(true)
      })
  }, [refresh]) // eslint-disable-line react-hooks/exhaustive-deps

  return { equipmentImage, isLoaded }
}

export default useEquipmentImage
